export const hasPermission = (role, permissions) => permissions.some(p => role.includes(p))